import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import React from "react";
import useProductDetailPageAttrQuery from "../hooks/useProductDetailPageAttrQuery";

const Faq = () => {
  const { data: result } = useProductDetailPageAttrQuery();
  const { faq } = result!.data.attributes;

  return (
    <Box>
      <Accordion>
        <SimpleGrid
          columns={{ base: 1, md: 2 }}
          spacing={4}
          mb={20}
          alignItems="start"
        >
          {faq.map((item, index) => (
            <Box
              key={index}
              border={"1px solid #C7C7C7"}
              borderRadius={"5px"}
              p={2}
            >
              <AccordionItem border={0}>
                <AccordionButton borderWidth={0} borderColor={"transparent"}>
                  <Box as="span" flex="1" textAlign="left">
                    <Text>{item.question}</Text>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text>{item?.answer}</Text>
                </AccordionPanel>
              </AccordionItem>
            </Box>
          ))}
        </SimpleGrid>
      </Accordion>
    </Box>
  );
};
export default Faq;
